<!-- kzd-ac AC-R6: over the whole app, the sign-in page included. No dismissal: a newer build is the only way past it.
     Nothing underneath is stopped — the queue, the outbox and the offline sync keep sending; every other child of
     ion-app is inert meanwhile (MV-4, inert-siblings.ts). -->
<div class="kz-upd" role="alertdialog" aria-modal="true" tabindex="-1" [attr.aria-label]="title()" data-kz="update-required">
  <div class="kz-upd__col">
    <app-kz-brand-lockup class="kz-upd__brand" [showStrapline]="false"></app-kz-brand-lockup>

    <app-kz-empty-state
      class="kz-upd__state"
      tone="warning"
      icon="cloud-download-outline"
      actionIcon="open-outline"
      [heading]="title()"
      [message]="message()"
      [actionLabel]="actionLabel()"
      (action)="act()"
    ></app-kz-empty-state>

    @if (unsentText()) {
      <app-kz-inline-alert class="kz-upd__unsent" tone="info" icon="cloud-upload-outline" data-kz="update-unsent">
        {{ unsentText() }}
      </app-kz-inline-alert>
    }

    <p class="kz-upd__versions" data-kz="update-versions">{{ versionsText() }}</p>
  </div>
</div>
